var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarDeleteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1870_49188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8907 9.72363L16.5 14.1143L12.1094 9.72363L10.224 11.609L14.6147 15.9996L10.224 20.3903L12.1094 22.2756L16.5 17.885L20.8907 22.2756L22.776 20.3903L18.3853 15.9996L22.776 11.609L20.8907 9.72363Z",
    fill: "#067D89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0C13.3355 0 10.2421 0.938383 7.61088 2.69649C4.9797 4.45459 2.92894 6.95345 1.71793 9.87706C0.506933 12.8007 0.190079 16.0177 0.807443 19.1214C1.42481 22.2251 2.94866 25.0761 5.1863 27.3137C7.42394 29.5513 10.2749 31.0752 13.3786 31.6926C16.4823 32.3099 19.6993 31.9931 22.6229 30.7821C25.5466 29.5711 28.0454 27.5203 29.8035 24.8891C31.5616 22.2579 32.5 19.1645 32.5 16C32.4954 11.7579 30.8082 7.69095 27.8086 4.69136C24.8091 1.69177 20.7421 0.00458811 16.5 0V0ZM16.5 29.3333C13.8629 29.3333 11.2851 28.5513 9.0924 27.0863C6.89975 25.6212 5.19078 23.5388 4.18161 21.1024C3.17244 18.6661 2.9084 15.9852 3.42287 13.3988C3.93734 10.8124 5.20722 8.43661 7.07192 6.57191C8.93661 4.70721 11.3124 3.43733 13.8988 2.92286C16.4852 2.40839 19.1661 2.67244 21.6024 3.68161C24.0388 4.69077 26.1212 6.39974 27.5863 8.5924C29.0513 10.7851 29.8333 13.3629 29.8333 16C29.8295 19.535 28.4234 22.9242 25.9238 25.4238C23.4242 27.9234 20.035 29.3294 16.5 29.3333V29.3333Z",
    fill: "#067D89"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1870_49188"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarDeleteIcon);
export default __webpack_public_path__ + "static/media/car-delete-icon.1072982f3c4277fd9873c21974adcb3d.svg";
export { ForwardRef as ReactComponent };